import { observer } from 'mobx-react';
import { useMemo } from 'react';
import Skeleton from 'react-loading-skeleton';
import Picker from '../Pickers/Picker/Picker';
import { IPickerOption } from '../Pickers/Picker/types';
import TabPicker from '../Pickers/TabPicker/TabPicker';
import { LOCALES } from 'src/constants/main';
import { appStore } from 'src/mobx/appStore';
import { localeStore } from 'src/mobx/localesStore';
import { sidebarStore } from 'src/mobx/sidebarStore';
import { TLocale } from 'src/types/main';
import './style.scss';

interface IProps {
  inPicker?: boolean;
}

const LanguageSwitcher: React.FC<IProps> = observer((props: IProps): JSX.Element | null => {
  const languageOptions = useMemo((): IPickerOption[] => {
    return [
      { label: 'english', value: LOCALES.EN },
      { label: 'txt_arabic', value: LOCALES.AR },
    ];
  }, []);

  const onLanguageChange = (option: TLocale) => {
    localeStore.setLocale(option);
  };

  const onPickerLanguageChage = (options: IPickerOption[]) => {
    localeStore.setLocale(options[0].value as TLocale);
  };

  switch (true) {
    case !sidebarStore.isOpen:
      return null;
    case !appStore.timestamp || !localeStore.localizationLoaded:
      return <Skeleton width={130} height={40} />;
    case props.inPicker:
      return (
        <Picker<TLocale>
          options={languageOptions}
          selectedOptions={[
            { label: localeStore.language === LOCALES.EN ? localeStore.t('english') : localeStore.t('txt_arabic'), value: localeStore.language },
          ]}
          onSelect={onPickerLanguageChage}
          className="language-picker__alt-picker"
          hideResetIcon
          hideSelectedIcons
          noReset
        />
      );
    default:
      return (
        <TabPicker
          value={localeStore.language}
          options={languageOptions}
          onChange={(val) => onLanguageChange(val)}
          className="language-picker"
          tabClassName="language-picker__tab"
        />
      );
  }
});

export default LanguageSwitcher;
